var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8F8",
    d: "M48.75 60h-37.5C5.036 60 0 54.964 0 48.75v-37.5C0 5.036 5.036 0 11.25 0h37.5C54.964 0 60 5.036 60 11.25v37.5C60 54.964 54.964 60 48.75 60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A4A4",
    d: "M32.813 15H18.437C16.537 15 15 16.538 15 18.437V37.81c0 1.901 1.538 3.439 3.437 3.439h7.813v-7.5c0-.437.062-.862.163-1.262-.05.013-.1.013-.15.013h-6.262c-.689 0-1.251-.562-1.251-1.25 0-.689.563-1.251 1.249-1.251h6.262c.463 0 .876.262 1.088.637.9-1.149 2.312-1.888 3.9-1.888h5V18.437c0-1.9-1.537-3.437-3.437-3.437zm-12.814 5h5c.689 0 1.251.563 1.251 1.251S25.687 22.5 25 22.5h-5.001c-.686 0-1.249-.563-1.249-1.25 0-.689.563-1.25 1.249-1.25zm11.252 7.5H20c-.689 0-1.251-.562-1.251-1.25S19.313 25 20 25h11.25c.689 0 1.251.562 1.251 1.25-.002.688-.564 1.25-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A4A4",
    d: "M42.5 31.25H31.25c-1.38 0-2.499 1.12-2.499 2.5v8.75c0 1.38 1.12 2.5 2.5 2.5H42.5C43.88 45 45 43.88 45 42.5v-8.75c0-1.38-1.12-2.5-2.5-2.5zM41.25 42.5H32.5c-.69 0-1.251-.56-1.251-1.25v-5h11.25v5c.002.69-.559 1.25-1.249 1.25z",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReports);
export default __webpack_public_path__ + "static/media/ic-reports.06e2daa6.svg";
export { ForwardRef as ReactComponent };